module.exports = __webpack_public_path__ + "images/help_v2/guide-team-cc4c1302aba362fde30e613532043039.png";